var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2927,
    cy: 28.2927,
    r: 28.2927,
    fill: "#FFEBEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6933 25.3337C15.12 25.3337 14.6667 24.8803 14.6667 24.307V21.227C14.6667 17.6137 17.6133 14.667 21.2267 14.667H24.3067C24.88 14.667 25.3333 15.1203 25.3333 15.6937C25.3333 16.267 24.88 16.7203 24.3067 16.7203H21.2267C18.7333 16.7203 16.72 18.747 16.72 21.227V24.307C16.72 24.8803 16.2533 25.3337 15.6933 25.3337Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3067 25.3337C39.7467 25.3337 39.28 24.8803 39.28 24.307V21.227C39.28 18.7337 37.2533 16.7203 34.7733 16.7203H31.6933C31.12 16.7203 30.6667 16.2537 30.6667 15.6937C30.6667 15.1337 31.12 14.667 31.6933 14.667H34.7733C38.3867 14.667 41.3333 17.6137 41.3333 21.227V24.307C41.3333 24.8803 40.88 25.3337 40.3067 25.3337Z",
    fill: "#B90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7733 41.3329H32.92C32.36 41.3329 31.8933 40.8796 31.8933 40.3062C31.8933 39.7462 32.3467 39.2796 32.92 39.2796H34.7733C37.2667 39.2796 39.28 37.2529 39.28 34.7729V32.9329C39.28 32.3729 39.7333 31.9062 40.3067 31.9062C40.8667 31.9062 41.3333 32.3596 41.3333 32.9329V34.7729C41.3333 38.3862 38.3867 41.3329 34.7733 41.3329Z",
    fill: "#B90022"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3067 41.3337H21.2267C17.6133 41.3337 14.6667 38.387 14.6667 34.7737V31.6937C14.6667 31.1203 15.12 30.667 15.6933 30.667C16.2667 30.667 16.72 31.1203 16.72 31.6937V34.7737C16.72 37.267 18.7467 39.2803 21.2267 39.2803H24.3067C24.8667 39.2803 25.3333 39.7337 25.3333 40.307C25.3333 40.8803 24.88 41.3337 24.3067 41.3337Z",
    fill: "#B90022"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6133 26.9736H34.8H21.2H19.3867C18.8133 26.9736 18.36 27.4403 18.36 28.0003C18.36 28.5603 18.8133 29.027 19.3867 29.027H21.2H34.8H36.6133C37.1867 29.027 37.64 28.5603 37.64 28.0003C37.64 27.4403 37.1867 26.9736 36.6133 26.9736Z",
    fill: "#B90022"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 30.5876V31.0276C21.2 33.241 22.9867 35.0276 25.2 35.0276H30.8C33.0133 35.0276 34.8 33.241 34.8 31.0276V30.5876C34.8 30.4276 34.68 30.3076 34.52 30.3076H21.48C21.32 30.3076 21.2 30.4276 21.2 30.5876Z",
    fill: "#B90022"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 25.4136V24.9736C21.2 22.7603 22.9867 20.9736 25.2 20.9736H30.8C33.0133 20.9736 34.8 22.7603 34.8 24.9736V25.4136C34.8 25.5736 34.68 25.6936 34.52 25.6936H21.48C21.32 25.6936 21.2 25.5736 21.2 25.4136Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.f887cfa9e7c36da4dac9713a80048b64.svg";
export { ForwardRef as ReactComponent };